import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';
import LoadingScreen from '../components/shared/LoadingScreen';

export const ProtectedRoute = ({ children }) => {
  const { user, loading } = useSelector((state) => state.auth);
  const location = useLocation();

  // Show loading screen while authentication status is being determined
  if (loading) {
    return <LoadingScreen />;
  }

  // If there is no authenticated user, redirect to the login page
  if (!user) {
    // CRITICAL FIX: Only preserve bypass token in URL if maintenance mode is actually enabled
    // The ProtectedRouteWrapper handles maintenance mode checks, so we should NOT
    // automatically add bypass token to login URL here - that causes the bypass token
    // to appear in URL even when maintenance is disabled
    // The login page will check localStorage for bypass token if needed
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // If authenticated, render the children (the protected components)
  return children;
};
